import { useGeneralSettingsData } from "@/lib/settings/generalSettingsData";
import { Skeleton } from "@mui/material";

export default function GeneralSettingsSkeleton() {
  const { isDarkMode } = useGeneralSettingsData();

  const skeletonSx = { bgcolor: isDarkMode ? "grey.800" : "", height: 50 };

  return (
    <div className="p-6 space-y-6">
      <div>
        <Skeleton
          animation="wave"
          variant="text"
          width={200}
          height={32}
          className="mb-4"
          sx={skeletonSx}
        />

        <div className="space-y-4">
          <Skeleton
            animation="wave"
            variant="text"
            width={180}
            height={24}
            sx={skeletonSx}
          />

          {/* Organization info skeletons */}
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Skeleton
                animation="wave"
                variant="text"
                width={140}
                height={20}
                sx={skeletonSx}
              />
              <Skeleton
                animation="wave"
                variant="rectangular"
                height={40}
                sx={skeletonSx}
              />
            </div>
            <div className="space-y-2">
              <Skeleton
                animation="wave"
                variant="text"
                width={80}
                height={20}
                sx={skeletonSx}
              />
              <Skeleton
                animation="wave"
                variant="rectangular"
                height={40}
                sx={skeletonSx}
              />
            </div>
          </div>

          <div className="space-y-2">
            <Skeleton
              animation="wave"
              variant="text"
              width={160}
              height={20}
              sx={skeletonSx}
            />
            <Skeleton
              animation="wave"
              variant="rectangular"
              height={96}
              sx={skeletonSx}
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Skeleton
                animation="wave"
                variant="text"
                width={120}
                height={20}
                sx={skeletonSx}
              />
              <Skeleton
                animation="wave"
                variant="rectangular"
                height={40}
                sx={skeletonSx}
              />
            </div>
            <div className="space-y-2">
              <Skeleton
                animation="wave"
                variant="text"
                width={60}
                height={20}
                sx={skeletonSx}
              />
              <Skeleton
                animation="wave"
                variant="rectangular"
                height={40}
                sx={skeletonSx}
              />
            </div>
          </div>

          {/* Branding section skeleton */}
          <div className="pt-4 space-y-4">
            <Skeleton
              animation="wave"
              variant="text"
              width={160}
              height={24}
              sx={skeletonSx}
            />

            {/* Logo upload skeleton */}
            <div className="space-y-4">
              <div className="space-y-2">
                <Skeleton
                  animation="wave"
                  variant="text"
                  width={120}
                  height={20}
                  sx={skeletonSx}
                />
                <Skeleton
                  animation="wave"
                  variant="text"
                  width={280}
                  height={16}
                  sx={skeletonSx}
                />

                <div className="flex items-center gap-4">
                  <div className="flex-shrink-0">
                    <Skeleton
                      animation="wave"
                      variant="rectangular"
                      width={96}
                      height={40}
                      className="rounded-lg"
                      sx={skeletonSx}
                    />
                    <Skeleton
                      animation="wave"
                      variant="text"
                      width={50}
                      height={12}
                      className="mt-1"
                      sx={skeletonSx}
                    />
                  </div>
                  <div className="flex-1">
                    <Skeleton
                      animation="wave"
                      variant="rectangular"
                      height={40}
                      className="rounded"
                      sx={skeletonSx}
                    />
                  </div>
                </div>
              </div>

              {/* Color pickers skeleton */}
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Skeleton
                    animation="wave"
                    variant="text"
                    width={100}
                    height={20}
                    sx={skeletonSx}
                  />
                  <Skeleton
                    animation="wave"
                    variant="text"
                    width={240}
                    height={16}
                    sx={skeletonSx}
                  />
                  <div className="flex items-center gap-3">
                    <Skeleton
                      animation="wave"
                      variant="rectangular"
                      width={48}
                      height={40}
                      className="rounded"
                      sx={skeletonSx}
                    />
                    <Skeleton
                      animation="wave"
                      variant="rectangular"
                      height={40}
                      className="flex-1 rounded"
                      sx={skeletonSx}
                    />
                  </div>
                </div>
                <div className="space-y-2">
                  <Skeleton
                    animation="wave"
                    variant="text"
                    width={120}
                    height={20}
                    sx={skeletonSx}
                  />
                  <Skeleton
                    animation="wave"
                    variant="text"
                    width={260}
                    height={16}
                    sx={skeletonSx}
                  />
                  <div className="flex items-center gap-3">
                    <Skeleton
                      animation="wave"
                      variant="rectangular"
                      width={48}
                      height={40}
                      className="rounded"
                      sx={skeletonSx}
                    />
                    <Skeleton
                      animation="wave"
                      variant="rectangular"
                      height={40}
                      className="flex-1 rounded"
                      sx={skeletonSx}
                    />
                  </div>
                </div>
              </div>

              {/* Color preview skeleton */}
              <div className="space-y-2">
                <Skeleton
                  animation="wave"
                  variant="text"
                  width={100}
                  height={20}
                  sx={skeletonSx}
                />
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  height={120}
                  className="rounded-lg"
                  sx={skeletonSx}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-end pt-4 border-t border-gray-200">
        <Skeleton
          animation="wave"
          variant="rectangular"
          width={140}
          height={40}
          className="rounded"
          sx={skeletonSx}
        />
      </div>
    </div>
  );
}
